import { withAccountUtm } from "@/utils/account-utm";

export const MANAGED_PLATFORM_URL = withAccountUtm(
  "https://www.withmanaged.com/r/cosmetic-college",
  {
    utm_medium: "referral",
    utm_campaign: "student-discount-offer",
    utm_content: "claim-free-website",
  },
);

export const MANAGED_PLATFORM_IMAGE_URL = "/images/managed-app.png";
